export enum LvfAssignmentType {
  LOAN = 0,           // Prêt temporaire
  FOR_WORK = 1,        // Véhicule de fonction
}
